import { Component, Input } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FieldBase } from '@nagel-types';
import { IconComponent } from '@nagel-assests';

@Component({
    selector: 'lib-checkbox',
    imports: [
        MatCheckboxModule,
        IconComponent,
        MatFormFieldModule,
        ReactiveFormsModule,
        FormsModule
    ],
    templateUrl: './checkbox.component.html',
    styleUrl: './checkbox.component.scss'
})
export class CheckboxComponent extends BaseFieldComponent {
  @Input() override field!: FieldBase<unknown>;
  @Input() override form!: FormGroup;

  @Input() key: string = '';
  @Input() icon: string = '';
  @Input() className: string = '';
  @Input() labelClassName: string = '';
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() changeHandler: (fieldName: string, value: boolean) => void = () => {};

  ngOnInit() {
      this.key = this.field?.key ?? this.key;
      this.icon = this.field?.icon ?? this.icon;
      this.className = this.field?.className ?? this.className;
      this.labelClassName = this.field?.labelClassName ?? this.labelClassName;
      this.label = this.field?.label ?? this.label;
      this.disabled = this.field?.disabled ?? this.disabled;
  }

  getLabelPosition = () => {
      return this.icon === '' ? 'after' : 'before';
  };

  handleChange(event: any) {
      const isChecked = event.checked;
      this.changeHandler && this.changeHandler(this.key, isChecked);
  }
}